import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const StockholderForm = lazy(
  () => import('@components/Group/Portfolio/StockholderForm')
);

/** 포트폴리오 상세 > 주주 현황 > 등록/수정하기 */
const StockholderNew = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <StockholderForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default StockholderNew;
